import { render, staticRenderFns } from "./GroundNutrients.vue?vue&type=template&id=255f8228"
import script from "./GroundNutrients.vue?vue&type=script&lang=js"
export * from "./GroundNutrients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports